module.exports = __webpack_public_path__ + "img/entia-portafolio-energia-carrusel-4.77cd4843.webp";